import { Component, forwardRef, Inject, Input, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { firstValueFrom } from "rxjs";
import { ErrorMessages } from "../../../common/constants";
import { ME } from "../../../common/endpoints";
import { AlgorithmOutput, User } from "../../../model";
import { AuthenticationService } from "../../../service/authentication.service";
import { HttpService } from "../../../service/http.service";
import { ErrorUtility } from "../../../utility/error-utility";
import { AbstractAdvancedSearchAddPropertiesDialog } from "../abstract-advanced-search-add-properties-dialog.component";

@Component({
    selector: 'work-session-advanced-search-add-properties-dialog',
    template: require('./work-session-advanced-search-add-properties-dialog.component.html')
})
export class WorkSessionAdvancedSearchAddPropertiesDialog extends AbstractAdvancedSearchAddPropertiesDialog {

    @Input() postComputationResultFieldOutputs: { resultField: string, algorithmOutputs: AlgorithmOutput[] }[];

    @ViewChild('postComputationForm') postComputationForm: NgForm;

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) {
        super();
    }

    protected updateSearchFields(): void {
        this.user = this.authenticationService.getUser();
        this.selectedProperties = this.user.workSessionsSearchFields;
    }

    save(): void {
        let newSelectedProperties = [];
        const rawValues = this.propertiesForm.form.getRawValue();
        Object.keys(rawValues).forEach(key => {
            if (rawValues[key] == true) {
                newSelectedProperties.push(key);
            }
        });
        const postCompRawValues = this.postComputationForm.form.getRawValue();
        Object.keys(postCompRawValues).forEach(key => {
            if (postCompRawValues[key] == true) {
                newSelectedProperties.push(key);
            }
        })
        this.user.workSessionsSearchFields = newSelectedProperties;
        const body = Object.assign({}, this.user);
        firstValueFrom(this.httpService.put<User>(ME, body)).then(() => {
            this.saveAction.emit(newSelectedProperties);
            this.close();
        }).catch(err => this.error = ErrorUtility.getMessage(err, ErrorMessages.SAVE_DATA_ERROR));
    }

    override resetStatus(): void {
        const rawValues = this.propertiesForm.form.getRawValue();
        Object.keys(rawValues).forEach(key => {
            this.propertiesForm.controls[key].reset(this.isPropertyChecked(key));
        });
        const postCompRawValues = this.postComputationForm.form.getRawValue();
        Object.keys(postCompRawValues).forEach(key => {
            this.postComputationForm.controls[key].reset(this.isPropertyChecked(key));
        });
    }
}